<template>
  <div class="container-fluid mx-auto" ref="popupContainer">
    <vs-popup :active.sync="showHistorySelectionPopup" title="Consultation historique : sélection du client">
      <div class="vx-row" style="width: 300px; height:50px;">
        <div class="vx-col sm:w-2/3 mt-2">
          <vs-select
                v-model="selectedSocietyPopup"
                class="w-full select-medium mr-2"
                placeholder="Clients"
                autocomplete
              >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in societies"
                class="w-full"
              />
          </vs-select>
        </div>
        <div class="vx-col sm:w-1/3">
          <vs-button color="primary" @click="displaySelectedSocietyHistoryPopup(selectedSocietyPopup)">Sélectionner</vs-button>
        </div>
      </div>
    </vs-popup>
    <vx-card v-if="$acl.check('accountmanager')" class="mb-1">
      <div class="vx-row" style="justify: flex-end;">
        <div class="vx-col mb-2">
          <vs-button class="shadow-lg"
                      icon-pack="feather" icon="icon-plus-circle"
                      color="primary"
                      @click="$router.push({ name: 'new_entity' })"
            >Nouvelle tache</vs-button
          >
        </div>
        <div  class="vx-col mb-2">
          <vs-button class="shadow-lg"
                        color="primary"
                        @click="displayHistorySelectionPopup"
            >Historique</vs-button
          >
        </div>
        <vs-spacer />
        <!-- <div class="vx-col mb-2">
          <vs-button class="float-right" icon-pack="feather" icon="icon-download-cloud" color="dark" @click="exportData(displayedTasks)">Exporter</vs-button>
        </div> -->
      </div>
    </vx-card>
    <vx-card class="mb-1">
		<vs-table noDataText="" class="table-filter" ref="tableFilter">
			<template slot="thead">
				<vs-th></vs-th>
				<vs-th>Filtres</vs-th>
			</template>
			<template>
				<vs-tr>
					<vs-td style="width: 50px">
						<div
							class="expand-icon-wrapper"
							@click="toggleFilterExpand()"
							style="cursor: pointer; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px;"
						>
							<vs-icon
								:icon="filterExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
								size="small"
								style="pointer-events: none"
							/>
						</div>
					</vs-td>
					<vs-td>Cliquez pour afficher/masquer les filtres</vs-td>
				</vs-tr>
				<tr
					v-if="filterExpanded"
					key="filter-expand"
					class="expand-row"
				>
					<td colspan="2" style="padding: 10px">
      <div class="vx-row">
        <div v-if="$acl.check('accountmanager')" class="vx-col px-1 mb-2">
          <vs-select
                v-model="accountManagerFilter"
                class="w-full select-medium mr-2"
                placeholder="Consultant"
                autocomplete
              >
              <vs-select-item
                value=""
                text="Tous les consultants"
                class="w-full"
              />
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.firstname + ' ' + item.lastname"
                v-for="(item, index) in account_managers"
                class="w-full"
              />
          </vs-select>
        </div>
        <div class="vx-col px-1 mb-2">
          <vs-input class="inputx" placeholder="Client" v-model="societyFilter" />
        </div>
        <div class="vx-col px-1 mb-2">
          <vs-input class="inputx" placeholder="N° Contrat" v-model="contractNumberFilter" />
        </div>
        <div class="vx-col px-1 mb-2">
          <vs-select
                autocomplete
                v-model="periodFilter"
                class="w-full select-medium mr-2"
                placeholder="Mois (Sélection multiple)"
                multiple
              >
              <vs-select-item
                :key="index"
                :value="item.id + 1"
                :text="item.text"
                v-for="(item, index) in lastThreeMonths"
                class="w-full"
              />
          </vs-select>
        </div>
        <div class="vx-col px-1 mb-2" style="display: flex; align-items: center;">
			<vs-switch color="primary" v-model="activeFilter">
				<span slot="on">Toutes les tâches</span>
				<span slot="off">Tâches à faire</span>
			</vs-switch>
        </div>
      </div>
					</td>
				</tr>
			</template>
		</vs-table>
      <div class="vx-row mt-2" v-if="displayedTasks.length > 0">
        <div class="vx-col">
          <strong>Nombre de tâches affichées : {{ displayedTasks.length }}</strong>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="displayedTasks.length > 0" style="max-height:69vh; overflow: auto;">
      <div class="vx-row w-full">
        <TasksCardTable
          :societies="societies"
          :tasks="displayedTasks"
          @update-task="updateTask($event)"
          @show-contract-popup="displayContractPopup($event)"
          @show-society-popup="displaySocietyPopup($event)"
          @show-history-popup="displayHistoryPopup(arguments)"
          @show-link-popup="displayLinkPopup($event)"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import TaskHistoryPopup from "@/components/popups/TaskHistoryPopup";
import TasksCardTable from "@/components/tables/TasksCardTable";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";
import XLSX from "xlsx";

export default {
	name: "TaskDashboard",
	components: {
		TasksCardTable,
		VxCard,
	},
	mixins: [utilsMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			contractNumberFilter: "",
			account_managers: null,
			filterExpanded: true,
			societyFilter: "",
			activeFilter: true,
			accountManagerFilter: "",
			periodFilter: [],
			contractNumberFilterOn: false,
			societyFilterOn: false,
			accountManagerFilterOn: false,
			periodFilterOn: false,
			contractsStatus: [],
			contractsAccountManagers: [],
			displayedSocieties: [],
			displayedTasks: [],
			displayedTasksFull: [],
			showSocietyPopup: false,
			showHistoryPopup: false,
			showHistorySelectionPopup: false,
			showContractPopup: false,
			selectedSociety: null,
			selectedSocietyPopup: null,
			activeUserId: null,
			statusOptions: [
				{id: 0, text: "À faire"},
				{id: 1, text: "Fait"},
				{id: 2, text: "Pas fait"},
			],
			lastThreeMonths: []
		};
	},
	computed: {
		societies: () => {
			return store.state.societies;
		},
		tasks: () => {
			return store.state.tasks;
		},
	},
	watch: {
		tasks: function(data) {
			this.getContractStatusContractIdSet(data, this.accountManagerFilter);
			this.getContractAccoutManagersByContractIdSet(data);
			this.displayedTasks = this.filterTasks(this.displayedTasksFull);
		},
		displayedTasksFull: function(data) {
			this.displayedTasks = this.filterTasks(data);
		},
		contractNumberFilter: function() {
			if(this.contractNumberFilter == "") {
				this.contractNumberFilterOn = false;
			}
			else{
				this.contractNumberFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.displayedTasksFull); //A CHANGER
		},
		societyFilter: function() {
			if(this.societyFilter == "") {
				this.societyFilterOn = false;
			}
			else{
				this.societyFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.displayedTasksFull); //A CHANGER
		},
		accountManagerFilter: function() {
			if(this.accountManagerFilter == "") {
				this.accountManagerFilterOn = false;
			}
			else{
				this.accountManagerFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.displayedTasksFull);
		},

		activeFilter: function() {
			this.activeFilterOn = true;
		    this.displayedTasks = this.filterTasks(this.displayedTasksFull);
		},

		periodFilter: function() {
			if(this.periodFilter.length < 1) {
				this.periodFilterOn = false;
			}
			else{
				this.periodFilterOn = true;
			}
			this.displayedTasks = this.filterTasks(this.displayedTasksFull);
		},
		account_managers: function(data) {
		},
		activeUserId: function(data) {
			this.accountManagerFilter = data;
			this.accountManagerFilterOn = true;
			this.displayedTasks = this.filterTasks(this.displayedTasksFull);
		}
	},
	beforeCreate() {
		this.$store.dispatch("getAllSocieties");
		this.$store.dispatch("getAllTasks");
		this.$store.dispatch("getAllCollaboratorsAvatar");
		this.$store.dispatch("getAllDocumentTypes");
	},
	created() {
		this.activeUserId = VueCookies.get("userInfo").id;
		this.setLastThreeMonths();
		this.getContractAccoutManagersByContractIdSet(this.tasks);
		this.getContractStatusContractIdSet(this.tasks, this.activeUserId);
		this.getAccountManagers();
	},
	mounted() {

	},
	methods: {
		toggleFilterExpand() {
			this.filterExpanded = !this.filterExpanded;
		},
		updateTask(task){
			// let foundIndex = this.displayedTasks.findIndex(row => row.id == task[0].id)
			let foundIndexFull = this.displayedTasksFull.findIndex(row => row.id == task[0].id);
			/*
			 * if(foundIndex >= 0){
			 *   this.displayedTasks[foundIndex].archivate = task[1]
			 * }
			 */
			if(foundIndexFull >= 0){
				this.displayedTasksFull[foundIndexFull].archivate = task[1];
				this.displayedTasks = this.filterTasks(this.displayedTasksFull);
			}
			//console.log(task[0], task[1]);
		},

		setLastThreeMonths(){
			let today = new Date(Date.now());

			let date_last_month = new Date(today);
			date_last_month.setMonth(today.getMonth() - 1);

			let date_last_last_month = new Date(today);
			date_last_last_month.setMonth(today.getMonth() - 2);

			this.lastThreeMonths = [
				{id: date_last_last_month.getMonth(), text: this.getMonthFrench(today.getMonth() -2) + " " + this.getYearFromMonth(today.getMonth() - 2, today)},
				{id: date_last_month.getMonth(), text: this.getMonthFrench(today.getMonth()- 1) + " " + this.getYearFromMonth(today.getMonth() - 1, today)},
				{id: today.getMonth(), text: this.getMonthFrench(today.getMonth()) + " " + this.getYearFromMonth(today.getMonth(), today)},
			];
		},
		getYearFromMonth(month, today){
			let year = month >= 0 ? today.getFullYear() : today.getFullYear() - 1;
			return year.toString().substring(2, 4);
		},
		/**
		 * Fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},

		/**
		 * Fetch all the societies
		 */
		getAllTasks() {
			this.$store.dispatch("getAllTasks");
		},

		/**
		 * Fetch account manager list
		 */
		getAccountManagers() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then(res => {
					this.account_managers = res.data;
				})
				.catch(err => {
					console.error(err);
				});
		},

		/**
		 * Get all contract IDs for all tasks
		 * @param {Object} tasks - Task List Object
		 * @return - Array of contract IDs
		 */
		getAllTasksContractIds(tasks){
			let contract_ids = [];
			for(let task of tasks){
				if(contract_ids.length > 0){
					if(!contract_ids.find(contract_id => contract_id == task.contract_id)){
						contract_ids.push(task.contract_id);
					}
				}
				else{
					contract_ids.push(task.contract_id);
				}
			}
			return contract_ids;
		},

		/**
		 * Fetch Contract account managers by contract ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getContractAccoutManagersByContractIdSet(tasks){
			let string_contract_ids = JSON.stringify(this.getAllTasksContractIds(tasks));
			if(string_contract_ids !== "[]"){
				this.$http
					.get(this.apiUrl + "users/all/amcfs", {
						params: {
							contractids: string_contract_ids
						}
					})
					.then(res => {
						//GROUP BY CONTRACT
						this.contractsAccountManagers = res.data;
					})
					.catch(err => {
						//console.log(err);
					});
			}
		},

		/**
		 * Fetch Contract status by contract ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getContractStatusContractIdSet(tasks, userId = null){
			let string_contract_ids = JSON.stringify(this.getAllTasksContractIds(tasks));
			if(string_contract_ids !== "[]"){
				this.$http
					.get(this.apiUrl + "contract/getstatus", {
						params: {
							contractids: string_contract_ids
						}
					})
					.then(res => {
						//GROUP BY CONTRACT
						this.contractsStatus = res.data;
						let task_list = [];
						for(let task of tasks){
							let contractStatus = this.contractsStatus.find(contract => contract.id == task.contract_id);
							if([1, 4].includes(contractStatus.status)) task_list.push(task);
						}
						this.displayedTasksFull = this.displayTask(task_list);
						if(userId){
							if(this.account_managers.filter(account_manager => account_manager.id == userId).length > 0){
								this.accountManagerFilter = userId;
								this.displayedTasks = this.filterTasks(this.displayedTasksFull);
							}
						}
						else{
							this.displayedTasks = this.displayTask(task_list);
						}
					})
					.catch(err => {
						//console.log(err);
					});
			}
		},

		getAccountManagerListForContract(contract_id){
			let filteredCU = this.contractsAccountManagers.filter(cu => cu.contracts_id == contract_id);
			let accountmanagerList = [];
			for(let row of filteredCU){
				accountmanagerList.push(row.id);
			}
			return accountmanagerList;
		},

		getSocietyName(societyId){
			let society_name = "";
			let society = this.societies.find(society => society.id == societyId);
			if(society){
				if(society.name){
					society_name = JSON.stringify(society.name);
				}
			}
			return society_name;
		},


		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			if(this.accountManagerFilterOn || this.contractNumberFilterOn || this.periodFilterOn || this.societyFilterOn || this.activeFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered tasks
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} accountManagerFilter - Id of the account manager
		 * @param {String} contractNumberFilter - Contract Number in String format can be partial
		 * @return {List} - Societies' list filtered
		 */
		filterTasks(tasks){
			let re = new RegExp("([T|Z])", "g");
			let tasksList = [];

			let searchKeyList = {};
			this.societyFilterOn ? searchKeyList["societyFilter"] = this.societyFilter.toLowerCase() : false;
			this.contractNumberFilterOn ? searchKeyList["contractNumberFilter"] = this.contractNumberFilter.toString() : false;
			this.accountManagerFilterOn ? searchKeyList["accountManagerFilter"] = this.accountManagerFilter : false;
			this.periodFilterOn ? searchKeyList["periodFilter"] = this.periodFilter : false;
			this.activeFilter ? false : searchKeyList["activeFilter"] = 0;

			for(let taskToFilter of tasks){
				let society_name = this.getSocietyName(taskToFilter.contract_society_id);

				if(society_name != "") society_name = society_name.toLowerCase();

				let taskSearchKeyList = {};
				this.societyFilterOn ? taskSearchKeyList["societyFilter"] = society_name : false;
				this.contractNumberFilterOn ? taskSearchKeyList["contractNumberFilter"] = taskToFilter.contract_id.toString() : false;
				this.accountManagerFilterOn ? taskSearchKeyList["accountManagerFilter"] = this.getAccountManagerListForContract(taskToFilter.contract_id) : false; // ADAPTER POUR RECUPERER LA LISTE D'AM LIEE AU CONTRAT DE LA TACHE
				let taskDate = new Date(taskToFilter.creation_date.replace(re, " "));
				this.periodFilterOn ? taskSearchKeyList["periodFilter"] = taskDate.getMonth() : false;
				this.activeFilter ? false : taskSearchKeyList["activeFilter"] = taskToFilter.archivate;

				let check = true;

				for(let key in searchKeyList) {
					if(typeof searchKeyList[key] == "string"){
						if(typeof taskSearchKeyList[key] == "string"){
							if(!taskSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof taskSearchKeyList[key] == "object"){
							let checkLoop = false;
							for(let value of taskSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								if(service_name.includes(searchKeyList[key])){
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(Array.isArray(taskSearchKeyList[key])){
							if(!taskSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else{
							if(key == "activeFilter" && searchKeyList[key] === 0){
								if(taskSearchKeyList[key] > 0){
									check = false;
									break;
								}
							}
						}
					}
				}

				if(check) tasksList.push(taskToFilter);
			}
			//return result
			this.activeFilterOn = false;
			return tasksList;
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displaySocieties(societies){
			let societiesList = [];
			if(this.displayedSocieties.length > 0){
				societiesList = this.displayedSocieties;
			}
			else{
				if(this.isFilterSet()){
					return societiesList;
				}
				else{
					return societies;
				}
			}

			//return result
			return societiesList;
		},
		displayContractPopup(contract) {
			this.$http
				.get(this.apiUrl + "contract/get/" + contract.toString())
				.then(res => {
					//Initialisation des données pour le popup
					this.showContractPopup = true;
					let contractProp = res.data[0];
					contractProp.society_name = this.getSocietyName(contractProp.society_id);
					//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
					let ComponentClass = Vue.extend(ContractInfoPopup);
					let contractPopup = new ComponentClass({
						propsData: {
							contract: res.data[0],
							popupActive: this.showContractPopup,
							router: this.$router,
							apiUrl: this.apiUrl
						}
					});
					contractPopup.$mount();
					this.$refs.popupContainer.appendChild(contractPopup.$el);
				})
				.catch(err => {
					console.error(err);
				});
		},

		displaySocietyPopup(society) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = society;
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl
				}
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		displayHistorySelectionPopup(){
			this.showHistorySelectionPopup = true;
		},

		displaySelectedSocietyHistoryPopup(societyId){
			let arr = [societyId];
			this.displayHistoryPopup(arr);
			this.showHistorySelectionPopup = false;
		},

		displayHistoryPopup(arr) {
			this.showHistoryPopup = true;
			//Récupération des tâches liées à la société
			let society_tasks = JSON.parse(JSON.stringify(this.tasks));
			//console.log("society_tasks", society_tasks);
			society_tasks = society_tasks.filter(task => task.contract_society_id == arr[0]);
			/*
			 *  for(let task of this.tasks){
			 *    if(task.contract_society_id == societyId){
			 *      society_tasks.push(task)
			 *    }
			 *  }
			 * Instancie la class TaskHistoryPopup pour mount sur la balise div principale
			 */
			let ComponentClass = Vue.extend(TaskHistoryPopup);
			let historyPopup = new ComponentClass({
				propsData: {
					tasks: society_tasks,
					popupActive: this.showHistoryPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					store: this.$store,
					contractId: arr[1]
				}
			});
			historyPopup.$mount();
			this.$refs.popupContainer.appendChild(historyPopup.$el);
		},

		displayTask(tasks){
			let task_list = [];
			let re = new RegExp("([T|Z])", "g");
			let today = new Date(Date.now());
			let strFinishLimit = today.toISOString().substring(0, 10);
			let finishLimit = new Date(strFinishLimit);
			for(let task of tasks){
				let strDateFormated = task.creation_date.replace(re, " ");
				let creation_date = new Date(strDateFormated);
				let strFinishedDateFormated = task.finished_date ? task.finished_date.substring(0, 10) : null;
				let finished_date = strFinishedDateFormated ? new Date(strFinishedDateFormated) : null;
				if(creation_date.getFullYear() == today.getFullYear() && creation_date.getMonth() == today.getMonth()){
					task_list.push(task);
				}
				else if(finished_date && finished_date >= finishLimit){
					task_list.push(task);
				}
				else if(task.archivate == 0){
					task_list.push(task);
				}
			}
			return task_list;
		},

		exportData(data){
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Liste des tâches";
			let header = {
				header: [
					"id",
					"archivate",
					"commentary",
					"contract_id",
					"contract_society_id",
					"creation_date",
					"finished_date",
					"frequency",
					"link",
					"mission_id",
					"recurrence",
					"status",
				],
				skipHeader: true,
				origin: -1
			};
			let header_names = [{
				id: "Identifiant",
				archivate: "Archivé",
				commentary: "Commentaire",
				contract_id: "Identifiant contact",
				contract_society_id: "Identifiant contrat de société ",
				creation_date: "Date de création",
				finished_date: "Fin de création",
				frequency: "Fréquence",
				link: "Lien",
				mission_id: "Identifiant mission",
				recurrence: "Récurrence",
				status: "Status",
			}];
			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);
			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);
			XLSX.writeFile(wb, "Tâches_export.xls");
		},
	}
};
</script>
<style lang="scss">
.table-filter{
	.con-tablex.vs-table--content{
		.vs-con-tbody.vs-table--tbody > table{
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead{
				display: none;
			}
			tr{
				.td-check{
					width: 40px;
				}
				td{
					border: none;
				}
			}
			.tr-expand > td > div{
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table{
				display: none;
			}
		}
		.not-data-table.vs-table--not-data{
			display: none;
		}
	}
}

.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: #f0f0f0;
	border-radius: 4px;
}
</style>